import { useEffect } from 'react';

import { Category } from '../../EligibleServices.types';
import { useCategorySpendLimitsStore, useSpendLimitsModalStore } from '../SpendLimitsModal/stores';

export const useSyncSpendLimits = (formattedData?: Category[]) => {
  const handleSetCategories = useSpendLimitsModalStore((state) => state.handleSetCategories);
  const spendLimits = useCategorySpendLimitsStore((state) => state.spendLimits);
  const handleSetSpendLimits = useCategorySpendLimitsStore((state) => state.handleSetSpendLimits);
  const handleSetSourceSpendLimits = useCategorySpendLimitsStore((state) => state.handleSetSourceSpendLimits);
  const sourceSpendLimits = useCategorySpendLimitsStore((state) => state.sourceSpendLimits);

  useEffect(() => {
    if (formattedData) {
      handleSetCategories(formattedData);

      const mergedSpendLimits = formattedData.map((category) => {
        const existing = spendLimits.find((item) => item.category_type === category.category);
        return existing || { category_type: category.category, category_spend_limit: '' };
      });

      const mergedSourceSpendLimits = formattedData.map((category) => {
        const existing = sourceSpendLimits.find((item) => item.category_type === category.category);
        return existing || { category_type: category.category, category_spend_limit: '' };
      });

      handleSetSpendLimits(mergedSpendLimits);
      handleSetSourceSpendLimits(mergedSourceSpendLimits);
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [formattedData, handleSetCategories, handleSetSpendLimits, handleSetSourceSpendLimits]);
};
